{
  "name": "databin-console-v2",
  "version": "3.0.87",
  "scripts": {
    "ng": "ng",
    "start": "node server.js",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build-dev": "ng build --configuration dev",
    "build-qa": "ng build --configuration qa",
    "build-prod": "ng build --configuration production",
    "build-rc": "ng build --configuration rc",
    "build-staging": "ng build --configuration staging",
    "serve-host": "ng serve --host 0.0.0.0 --port 4200"
  },
  "private": true,
  "packageManager": "npm@10.9.8",
  "dependencies": {
    "@angular-magic/ngx-gp-autocomplete": "^2.0.2",
    "@angular/cdk": "^21.0.0",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/google-maps": "^21.2.14",
    "@angular/localize": "^21.0.0",
    "@angular/material": "^21.0.1",
    "@angular/platform-browser": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@capacitor-community/background-geolocation": "^1.2.26",
    "@capacitor-community/file-opener": "^8.0.1",
    "@capacitor/android": "^8.4.0",
    "@capacitor/app": "^8.1.1",
    "@capacitor/core": "^8.4.0",
    "@capacitor/filesystem": "^8.1.2",
    "@capacitor/ios": "^8.4.0",
    "@capacitor/local-notifications": "^8.2.1",
    "@datorama/akita": "^7.1.1",
    "@googlemaps/js-api-loader": "^1.16.6",
    "@googlemaps/markerclusterer": "^2.6.2",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "^21.0.0",
    "angular-calendar": "^0.32.2",
    "angular-highcharts": "^21.0.2",
    "bootstrap": "^5.3.8",
    "chart.js": "^4.5.1",
    "chartjs-adapter-moment": "^1.0.1",
    "chartjs-plugin-annotation": "^3.1.0",
    "express": "^5.1.0",
    "highcharts": "^12.6.0",
    "lodash": "^4.18.1",
    "lottie-web": "^5.13.0",
    "luxon": "^3.7.2",
    "material-icons": "^1.13.14",
    "moment": "^2.30.1",
    "ng-circle-progress": "^1.7.1",
    "ng-table-virtual-scroll": "^1.6.1",
    "ng2-nouislider": "^2.0.0",
    "ngx-lottie": "^21.2.0",
    "ngx-mat-select-search": "^9.0.0",
    "ngx-otp-input": "^0.11.4",
    "ngx-papaparse": "^8.0.0",
    "normalize.css": "^8.0.1",
    "nouislider": "^15.8.1",
    "pako": "^2.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "wnumb": "^1.2.0",
    "xlsx": "^0.18.5",
    "xlsx-js-style": "^1.2.0",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.0",
    "@capacitor/cli": "^8.4.0",
    "@playwright/test": "^1.61.0",
    "@types/express": "^5.0.1",
    "@types/luxon": "^3.7.1",
    "@types/node": "^20.17.19",
    "dotenv": "^17.4.2",
    "jsdom": "^28.0.0",
    "prettier": "^3.8.1",
    "typescript": "~5.9.0",
    "vitest": "^4.0.8"
  }
}
